import { render, staticRenderFns } from "./disease_symptom_set.vue?vue&type=template&id=49d20764&scoped=true"
import script from "./disease_symptom_set.vue?vue&type=script&lang=js"
export * from "./disease_symptom_set.vue?vue&type=script&lang=js"
import style0 from "./disease_symptom_set.vue?vue&type=style&index=0&id=49d20764&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d20764",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49d20764')) {
      api.createRecord('49d20764', component.options)
    } else {
      api.reload('49d20764', component.options)
    }
    module.hot.accept("./disease_symptom_set.vue?vue&type=template&id=49d20764&scoped=true", function () {
      api.rerender('49d20764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/knowledge/disease_symptom_set.vue"
export default component.exports